import { DatePipe } from '@angular/common';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { EmergencyService } from '../services/emergency.service';
import { SchedulePassActivityService } from '../services/schedule-pass-activity.service';
import { ScreenService } from '../services/screen.service';

@Component({
	selector: 'top-bar-schedule-pass',
	templateUrl: './top-bar-schedule-pass.component.html',
	providers: [DatePipe],
})
export class TopBarSchedulePassComponent {
	@ViewChild('passButtonsContainer') passButtonsContainer: ElementRef<HTMLDivElement> | undefined;

	constructor(
		public dialog: MatDialog,
		private router: Router,
		public screenService: ScreenService,
		public emergencyService: EmergencyService,
		private schedulePassForm: SchedulePassActivityService
	) {}

	showScheduleForm(): void {
		if (!this.router.url.includes('main/passes-calendar')) {
			this.router.navigate(['main', 'passes-calendar']);
		}
		this.schedulePassForm.ShowForm();
	}
}
